import React from "react";
import SelectInput from "@components/UI/Inputs/SelectInput/SelectInput";
import { defaultOptionsMap } from "./config";
import { OffersSortProps } from "./types";

export const OffersSort = ({
    className,
    value,
    onChange,
    variant = "company"
}: OffersSortProps) => {
    const options = defaultOptionsMap[variant];

    return (
        <SelectInput
            className={className}
            instanceId={`offers-sort-${variant}`}
            width={200}
            isClearable={false}
            isSearchable={false}
            value={options.find((opt) => opt.value === value) || options[0]}
            onChange={(val) => onChange(val?.value || "")}
            options={options}
            ariaLabel="Сортировка объявлений"
        />
    );
};